import gql from "graphql-tag";

export const SAVE_ADJUSTED_AMOUNT = gql`
	mutation SaveAdjustedAmount($input: [SaveAdjustedAmountInput!]!) {
		SaveAdjustedAmount(request: $input)
	}
`;

export const GET_ALL_REFUNDS_OF_RECORD = gql`
	query GetAllRefundsOfRecord($refundIds: [ID!]!) {
		refunds(where: { id_IN: $refundIds }) {
			id
			agreementId
			documentStatus
			amount
			adjustedAmount
			tenantIds
			currency
			sourceFinancialDataPoint(where: { isDeleted: false }) {
				uuid
				isLast
				isDelta
				basePrice
				quantity
				evaluates {
					id
					tenantId
					isDeleted
					isRevoked
					status
					type {
						localizationKey
					}
					financialDataPoints(where: { isDeleted: false }) {
						isLast
						isDelta
						isDeleted
						variable
						uuid
						sourceRefund {
							id
							adjustedAmount
							amount
							isDeleted
							status
						}
					}
				}
			}
		}
	}
`;
